import { CreditUsageType } from '../definition';

export const CreditUsageTitle: Record<CreditUsageType, string> = {
  CONTACT_PROFILE_REVEAL: 'Unlock Profile Insights',
  CONTACT_JOB_CHANGE: 'Saved Contact — Job Change',
  CONTACT_PROFILE_UPDATE: 'Saved Contact — Data Update',
  CONTACT_EMAIL_FINDING: 'Valid Email Found',
  CONTACT_ENRICH_EMAIL: 'Saved Contact — Update & Find Email',
  CONTACT_EMAIL_REVERIFICATION: 'Saved Email — Re-Validate',
  CONTACT_PHONE_FINDING: 'Mobile Found',
  CONTACT_STORAGE_BASIC: 'Basic Contact Storage',
  CONTACT_STORAGE_ENRICH: 'CSV Contact Enrichment',
  CONTACT_STORAGE_AI: 'Lookalike Contact Storage',
  ACCOUNT_STORAGE_BASIC: 'Basic Company Storage',
  ACCOUNT_STORAGE_AI: 'Lookalike Company Storage',
  CONTACT_ANALYSIS_REVEAL: 'AI Personality Sales — Unlock',
  CONTACT_ANALYSIS_UPDATE: 'AI Personality Sales — Update',
  ACCOUNT_STORAGE_ENRICH: 'CSV Company Enrichment',
};

/**
 * Credit types whose price is the sum of other types rather than a bootstrap key
 * of their own. The backend prices the parts and charges them together; there is
 * no combined key in `cost`, so summing here is the only way to quote it.
 *
 * Keep this list short. A type belongs here only when the backend has confirmed
 * the composition — see docs/credit-cost-mapping.md.
 */
export const CREDIT_USAGE_COMPOSITION: Partial<
  Record<CreditUsageType, CreditUsageType[]>
> = {
  // "Update Profile & Find Email": the server runs the job-change profile update
  // and then re-runs Find Email against the new company.
  [CreditUsageType.CONTACT_ENRICH_EMAIL]: [
    CreditUsageType.CONTACT_JOB_CHANGE,
    CreditUsageType.CONTACT_EMAIL_FINDING,
  ],
};

/**
 * The bootstrap `cost` keys a credit type is priced from — itself for an ordinary
 * type, its parts for a composite one.
 */
export function creditUsageCostKeys(type: CreditUsageType): CreditUsageType[] {
  return CREDIT_USAGE_COMPOSITION[type] ?? [type];
}

/** Display order for credit usage lists (e.g. pricing “How credits work”). */
export const CREDIT_USAGE_DISPLAY_ORDER: readonly CreditUsageType[] = [
  CreditUsageType.CONTACT_STORAGE_BASIC,
  CreditUsageType.CONTACT_STORAGE_AI,
  CreditUsageType.ACCOUNT_STORAGE_BASIC,
  CreditUsageType.ACCOUNT_STORAGE_AI,
  CreditUsageType.CONTACT_JOB_CHANGE,
  CreditUsageType.CONTACT_PROFILE_UPDATE,
  CreditUsageType.CONTACT_PROFILE_REVEAL,
  CreditUsageType.CONTACT_ENRICH_EMAIL,
  CreditUsageType.CONTACT_EMAIL_FINDING,
  CreditUsageType.CONTACT_EMAIL_REVERIFICATION,
  CreditUsageType.CONTACT_PHONE_FINDING,
  CreditUsageType.CONTACT_ANALYSIS_REVEAL,
  CreditUsageType.CONTACT_ANALYSIS_UPDATE,
  CreditUsageType.CONTACT_STORAGE_ENRICH,
  CreditUsageType.ACCOUNT_STORAGE_ENRICH,
] as const;
